// Generated from assets/icons/folder-active.svg (TA-11013).
// Ids are derived per instance via useSvgIdPrefix() so two copies on one
// screen cannot collide. Edit this file rather than re-adding the .svg.
import * as React from 'react';
import Svg, { Path, Defs, LinearGradient, Stop } from 'react-native-svg';

import { useSvgIdPrefix } from '@hooks/useSvgIdPrefix';

import type { SvgProps } from 'react-native-svg';

export const FolderActive = (props: SvgProps) => {
  const uid = useSvgIdPrefix();
  return (
    <Svg fill='none' viewBox='16.45 14.651 24 24' {...props}>
      <Path
        fill={`url(#${uid}-a)`}
        d='M18.45 30.977v-9.734A3.243 3.243 0 0 1 21.693 18h3.135a2.7 2.7 0 0 1 1.912.791l1.71 1.71h5.676a4.324 4.324 0 0 1 4.324 4.325v6.151a4.324 4.324 0 0 1-4.324 4.325H22.774a4.325 4.325 0 0 1-4.324-4.325'
      />
      <Defs>
        <LinearGradient
          id={`${uid}-a`}
          x1={21.95}
          x2={40.236}
          y1={20.163}
          y2={42.284}
          gradientUnits='userSpaceOnUse'>
          <Stop stopColor='#97D8C6' />
          <Stop offset={1} stopColor='#32866F' />
        </LinearGradient>
      </Defs>
    </Svg>
  );
};
